import GenericTableFilter from '../../../../../components/common/GenericTableFilter';

const VehicleAcceptanceFilters = ({ filterFields, columns, handleSearch, handleApplyFilters, handleResetFilters, customFilterTypes = {}, customFilterOptions = {} }) => {
    return (
        <div className="mb-2">
            <GenericTableFilter 
                filterFields={filterFields} 
                columns={columns} 
                initialFilters={{}} 
                onSearch={handleSearch} 
                onApplyFilters={handleApplyFilters} 
                onResetFilters={handleResetFilters} 
                customFilterTypes={customFilterTypes}
                customFilterOptions={customFilterOptions} 
            />
        </div>
    );
};

export default VehicleAcceptanceFilters;
